import { Map } from 'immutable'

export function getEntityMap(state, typename) {
  return state.get(typename) || Map()
}

export function getEntity(state, typename, id) {
  return getEntityMap(state, typename).get(id)
}

export const rehydrate = (field, { asArray } = {}) => (state, entity) => {
  const value = typeof field === 'function' ? field(entity) : entity[field]
  if (!value) {
    return null
  }
  const hydrate = ({ id, __typename }) => getEntity(state, __typename, id)
  return asArray ? value.map(hydrate) : hydrate(value)
}
